import React, { useEffect } from "react";
import { Col, Flex, Row } from "antd";
import { t } from "i18next";
import useFetch from "../../../../server/useFetch";
import { NewWidget } from "../../Atomics/NewWidget";
import { containerMiddlewareAdEPortoEnergy } from "../../../../server/constants.api";
import { unitConverterArrays, unitConvertSingleValue } from "../../../../utils/hooks/unitConverter";

export const GeneralCumulativeAnalysis = ({ filtersSelected }) => {
  const { data: analyticsCumulative, isFetching: analyticsCumulativeIsFetching, refetch: refetchanalyticsCumulative } = useFetch(
    "analytics/cumulative",
    "analyticsCumulative",
    {
      metric: filtersSelected?.metric,
      periodicity: filtersSelected?.periodicity,
      startDate: filtersSelected?.startDate,
      endDate: filtersSelected?.endDate
    },
    true,
    'POST',
    containerMiddlewareAdEPortoEnergy,
    filtersSelected?.ids
  );

  useEffect(() => {
    if (filtersSelected) {
      refetchanalyticsCumulative();
    }
  }, [filtersSelected]);

  return (
    <>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Flex gap={16} vertical="true">
              <NewWidget
                data={{
                  height: "151px",
                  justify: 'center',
                  background: "white",
                  title: "Total Consumption",
                  icon: "Bolt",
                  tooltip: t("Total Consumption"),
                  charts: [
                    {
                      chartType: "bigNumberChart",
                      chartId: "bigNumberChartThree",
                      isFetching: analyticsCumulativeIsFetching,
                      data: analyticsCumulative?.data?.totalConsumption ? getTotalConsumption(analyticsCumulative?.data) : null,
                    },
                  ],
                }}
              />
              <NewWidget
                data={{
                  height: "151px",
                  justify: 'center',
                  background: "white",
                  title: "GEE Emissions",
                  icon: "Emissions",
                  tooltip: t("GEE Emissions"),
                  charts: [
                    {
                      chartType: "bigNumberChart",
                      chartId: "bigNumberChartThree",
                      isFetching: analyticsCumulativeIsFetching,
                      data: analyticsCumulative?.data?.geeEmissions ? {
                        "number": analyticsCumulative?.data?.geeEmissions,
                        "unit": "tCO2eq"
                      } : null,
                    },
                  ],
                }}
              />
              <NewWidget
                data={{
                  height: "151px",
                  justify: 'center',
                  background: "white",
                  title: "Number of Installations",
                  icon: "Building",
                  tooltip: t("Number of Installations"),
                  charts: [
                    {
                      chartType: "bigNumberChart",
                      chartId: "bigNumberChartThree",
                      isFetching: analyticsCumulativeIsFetching,
                      data: analyticsCumulative?.data ? { number: Object.keys(analyticsCumulative?.data?.data).length } : null
                    },
                  ],
                }}
              />
            </Flex>
          </Col>
          <Col span={12}>
            <NewWidget
              data={{
                width: "auto",
                background: null,
                background: "white",
                title: t("Top Consumers"),
                icon: "Bolt",
                description: null,
                tooltip: t("Top Consumers"),
                charts: [
                  {
                    height: "412px",
                    chartType: "horizontalBarChartApex",
                    chartId: "topConsumersCharts",
                    isFetching: analyticsCumulativeIsFetching,
                    data: analyticsCumulative?.data ? serealizeTopTenChart(analyticsCumulative?.data) : null
                  }
                ],
              }}
            />
          </Col>
        </Row>
      </Col>
    </>
  );
};

const getTotalConsumption = (data) => {
  const { result, newUnit } = unitConvertSingleValue(data.totalConsumption, data.unit);

  return {
    number: result,
    unit: newUnit
  }
};

const serealizeTopTenChart = (data) => {
  const topTenValues = Object.values(data.data)
    .sort((a, b) => b.value - a.value) // Ordena em ordem decrescente
    .slice(0, 10);

  const { convertedResult, newUnit } = unitConverterArrays([topTenValues.map(x => x.value)], data.unit);

  return {
    "series": topTenValues.map((x, index) => {
      return {
        name: x.name,
        value: convertedResult?.[0]?.[index],//So it can display the converted value
        id: x.id
      }
    }),
    "categories": null,
    "xAxisType": null,
    "labelFormat": null,
    "tooltip": null,
    "markerSize": null,
    "unit": newUnit,
    "columnWidth": 20,
    "xAxisLabel": newUnit,
    'hideCSVIcon': true,
    "colors": null,
    "filename": "Gráfico exportado",
    "headerValue": "valores",
    "headerCategory": "Instalação",
    "hrefItem": "/home/register/registerDetail/",
    "tooltipName": "Consumo (GWh)"
  }
};